import { render, staticRenderFns } from "./teamChat.vue?vue&type=template&id=f4047a54&"
import script from "./teamChat.vue?vue&type=script&lang=js&"
export * from "./teamChat.vue?vue&type=script&lang=js&"
import style0 from "./teamChat.vue?vue&type=style&index=0&id=f4047a54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports